import React from "react";
import {Doughnut, Chart} from "react-chartjs-2";
import 'chartjs-plugin-datalabels';

const DOUGHNUT_DEFAULT_BAR_COLOR = '#dededc';
const DOUGHNUT_SELECTED_BAR_COLOR = '#fefefc';

let originalDoughnutDraw = Chart.controllers.doughnut.prototype.draw;
Chart.helpers.extend(Chart.controllers.doughnut.prototype, {
    draw: function() {
        originalDoughnutDraw.apply(this, arguments);

        const chart = this.chart.chart;
        const ctx = chart.ctx;
        const width = chart.width;
        const height = chart.height;

        //const fontSize = (height / 114).toFixed(2);
        //ctx.font = fontSize + "em Verdana";
        ctx.font = "18px Verdana";
        ctx.textBaseline = "middle";
        ctx.fillStyle = '#515151';

        const text = chart.config.data.text,
            textX = Math.round((width - ctx.measureText(text).width) / 2),
            textY = height / 2;

        ctx.fillText(text, textX, textY);
    }
});

class DoughnutTimeSelector extends React.Component {

    constructor(props) {
        super(props);
        this.doughnutRef = React.createRef();

        this.state = {
            data: this.constructDataObject(this.props.labels, this.props.centerText)
        };
    }

    componentDidMount() {
        this.selectFirstLabel(this.props.selectedLabelIndexes);
    };

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!this.arraysEqual(prevProps.labels, this.props.labels)) {
            this.setState({
                data: this.constructDataObject(this.props.labels, this.props.centerText)
            }, () => this.selectFirstLabel(this.props.selectedLabelIndexes));
        } else if (prevProps.centerText !== this.props.centerText) {
            this.setState({
                data: {
                    ...this.state.data,
                    text: this.props.centerText
                }
            });
        }
        if (prevProps.iterationRunning === false && this.props.iterationRunning) {
            this.handleStartChartIteration();
        }
    };

    constructDataObject = (labels, text) => {
        const doughnutBars = labels.length;
        return {
            labels: labels,
            datasets: [{
                data:                   Array(doughnutBars).fill(1),
                backgroundColor:        Array(doughnutBars).fill(DOUGHNUT_DEFAULT_BAR_COLOR),
                hoverBackgroundColor:   Array(doughnutBars).fill(DOUGHNUT_SELECTED_BAR_COLOR)
            }],
            text: text
        }
    };

    selectFirstLabel = (selectedLabelIndexes) => {
        this.state.data.datasets[0].backgroundColor[selectedLabelIndexes[0]] = DOUGHNUT_SELECTED_BAR_COLOR;
        this.doughnutRef.current.chartInstance.update();
    };

    arraysEqual = (arr1, arr2) => {
        if (arr1.length !== arr2.length) {
            return false;
        }
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }
        return true;
    };

    handleStartChartIteration = () => {
        if (this.props.selectedLabelIndexes.length === 0) {
            return;
        }
        this.executeDoughnutStepsIteration(this.state.data.datasets[0].backgroundColor.length - 1, this.doughnutRef);
    };

    executeDoughnutStepsIteration = (lastIndex, doughnutRef) => {
        let timerId = setInterval( () => {
            if (!this.props.iterationRunning) {
                clearInterval(timerId);
                return;
            }
            if (this.props.selectedLabelIndexes.length === 0) {
                this.props.iterationStop();
                clearInterval(timerId);
                return;
            }
            // one step forward
            let selectedBarIndexes = this.props.selectedLabelIndexes;
            selectedBarIndexes.forEach(function(part, index) {
                const currBarIndex = this[index];
                const nextBarIndex = currBarIndex === lastIndex ? 0 : currBarIndex + 1;
                this[index] = nextBarIndex;
            }, selectedBarIndexes);
            this.props.updateDoughnutSelectedIndexes(selectedBarIndexes);

            for (let i = 0; i < selectedBarIndexes.length; i++) {
                const barIndex = selectedBarIndexes[i];
                // remove last step selection
                const prevBarIndex = barIndex === 0 ? lastIndex : barIndex - 1;
                this.state.data.datasets[0].backgroundColor[prevBarIndex] = DOUGHNUT_DEFAULT_BAR_COLOR;
                // current step selection
                this.state.data.datasets[0].backgroundColor[barIndex] = DOUGHNUT_SELECTED_BAR_COLOR;
            }
            if (doughnutRef.current === null) {
                clearInterval(timerId);
                return;
            }
            doughnutRef.current.chartInstance.update();
        }, 1000);
    };

    doughnutOptions = () => {
        return {
            legend: {
                display: false
            },
            tooltips: {
                enabled: false
            },
            cutoutPercentage: 30,
            padding: "0px",
            defaultFontSize: "14px",
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
                datalabels: {
                    color: '#515151',
                    textAlign: 'center',
                    font: {
                        lineHeight: 1.6
                    },
                    fontStyle: "bold",
                    formatter: (value, ctx) => {
                        return this.state.data.labels[ctx.dataIndex];
                    }
                }
            },
            onClick: (evt, item) => {
                if (item.length === 0) {
                    return;
                }
                // handle doughnut bar selection
                const datasetIndex = item[0]._index;
                let selectedBarIndexes = this.props.selectedLabelIndexes;
                let newBarColor;
                const unselectedIndex = typeof (selectedBarIndexes.find(i => i === datasetIndex)) === 'undefined';
                if (unselectedIndex) {
                    // select bar
                    newBarColor = DOUGHNUT_SELECTED_BAR_COLOR;
                    selectedBarIndexes.push(datasetIndex);
                } else {
                    // unselect bar
                    newBarColor = DOUGHNUT_DEFAULT_BAR_COLOR;
                    selectedBarIndexes = selectedBarIndexes.filter(index => index !== datasetIndex);
                }

                this.props.updateDoughnutSelectedIndexes(selectedBarIndexes);
                this.state.data.datasets[0].backgroundColor[datasetIndex] = newBarColor;
                item[0]._model.backgroundColor = newBarColor;
            }
        };
    };

    render() {
        return (
            <Doughnut
                data={this.state.data}
                options={this.doughnutOptions()}
                ref={this.doughnutRef}
            />
        );
    }
}

export default DoughnutTimeSelector;


// WEBPACK FOOTER //
// ./src/main/content/bar-chart/DoughnutTimeSelector.js